export const FILTER_TYPES = {
  TEXT: 'text',
  SELECT: 'select',
  MULTI_SELECT: 'multi-select',
  MULTI_TEXT: 'multi-text',
  SEARCH: 'search',
  DATE: 'date',
  NUMBER: 'number',
  NUMBER_RANGE: 'number-range',
};

export const PAGE_SIZE_FILTER = {
  field: 'page_size',
  label: 'Page Size',
  type: FILTER_TYPES.SELECT,
  options: [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
    { value: '200', label: '200' },
  ],
};
